import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { BaseComponent } from '../../../common/base/base.component';
import { finalize, takeUntil } from 'rxjs/operators';

export interface AssetData {
  url: string;
  tokenId: string;
}

@Component({
  selector: 'app-choose-image',
  templateUrl: './choose-image.component.html',
  styleUrls: ['./choose-image.component.scss'],
})
export class ChooseImageComponent extends BaseComponent implements OnInit {
  @Input() formGroupRef: FormGroup | undefined;
  @Input() editMode: boolean | undefined;
  @Output() handleImageSelect: EventEmitter<string> =
    new EventEmitter<string>();

  public assetsData: AssetData[] = [];
  private cursor: { next: string; previous: string } = {
    next: '',
    previous: '',
  };
  public isLoading: boolean | undefined;

  constructor(private commonService: CommonService) {
    super();
  }

  ngOnInit(): void {
    this.getAssets();
  }

  private getAssets(cursor?: string): void {
    this.isLoading = true;
    this.commonService
      .retrieveAssets(cursor)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.isLoading = false))
      )
      .subscribe((data) => {
        this.cursor.next = data.next;
        this.cursor.previous = data.previous;
        this.assetsData = this.assetsData.concat(
          data.assets.map((asset: any) => ({
            url: asset.image_preview_url,
            tokenId: asset.token_id,
          }))
        );
      });
  }

  public handleScroll(): void {
    if (this.cursor.next) {
      this.getAssets(this.cursor.next);
    }
  }
}
